import { RootState } from '@/store/types';
import { Browser, BrowserState, BrowserPagination, SelectedBrowserType, TypeNode, BrowserTypesOfSearch, SearchTabNode } from './types';
import { Module, GetterTree, MutationTree, ActionTree, ActionContext } from 'vuex';
import { BrowserAPI, GetBrowserDetailsReq, GetSearchDetailsReq, GetBrowserTypesReq, GetBrowserDetailsByPageReq } from '@/api/browser';
import { DefaultPagination } from '../fileConstruction/index';
import { Task, TaskTypeEnum, TaskStatusEnum } from "@/store/modules/task/types";
import { taskAPI } from '@/api/task';

export const moduleName = "browser";

export enum BrowserGetters {
    getTaskIdList = "GET_TASK_ID_LIST",
    getSelectedTaskId = "GET_SELECTED_TASK_ID",
    getSearchTabList = "GET_SEARCH_TAB_LIST",
    getTypeList = "GET_TYPE_LIST",
    getTypesLoading = "GET_TYPES_LOADING",
    getBrowserDetails = "GET_BROWSER_DETAILS",
    getDetailsLoading = "GET_DETAILS_LOADING",
    getDetailsCount = "GET_DETAILS_COUNT",
    // getIsAllDetailsLoaded = "GET_IS_ALL_DETAILS_LOADED",
    getSelectType = "GET_SELECT_TYPE",
    getIsSearching = "GET_IS_SEARCHING",
    getIsSearchLoading = "GET_IS_SEARCH_LOADING",
    getSearchTarget = "GET_SEARCH_TARGET",
    getSearchFilter = "GET_SEARCH_FILTER",
    getSearchType = "GET_SEARCH_Type",
    getSearchTypes = "GET_SEARCH_TYPE",
    getIsSearchDetailsLoading = "GET_IS_SEARCH_DETAILS_LOADING",
    getSearchDetails = "GET_SEARCH_DETAILS",
    getIsDefaultTypeLoading = "GET_IS_DEFAULT_TYPE_LOADING",
}
export enum BrowserMutations {
    setTaskIdList = "SET_TASK_ID_LIST",
    setSearchTabList = "SET_SEARCH_TAB_LIST",
    deleteSearchTabList = "DELETE_SEARCH_TAB_LIST",
    setSelectedTaskId = "SET_SELECTED_TASK_ID",
    setTypeList = "SET_TYPE_LIST",
    setTypesLoading = "SET_TYPES_LOADING",
    setBrowserDetails = "SET_BROWSER_DETAILS",
    setBrowserDetailsByPage = "SET_BROWSER_DETAILS_BY_PAGE",
    setDetailsLoading = "SET_DETAILS_LOADING",
    setDetailsCount = "SET_DETAILS_COUNT",
    setIsAllDetailsLoaded = "SET_IS_ALL_DETAILS_LOADED",
    setSelectedType = "SET_SELECTED_TYPE",
    setIsSearchLoading = "SET_IS_SEARCH_LOADING",
    setIsSearching = "SET_IS_SEARCHING",
    setSearchTarget = "SET_SEARH_TARGET",
    setSearchFilter = "SET_SEARH_FILTER",
    setSearchType = "SET_SEARH_TYPE",
    setSearchTypes = "SET_SEARCH_TYPE",
    setIsSearchDetailsLoading = "SET_IS_SEARCH_DETAILS_LOADING",
    setSearchDetails = "SET_SEARCH_DETAILS",
    setIsDefaultTypeLoading = "SET_IS_DEFAULT_TYPE_LOADING",
    resetAll = "RESET_ALL",
    resetForChangeTask = "RESET_FOR_CHANGE_TASK",
}

export enum BrowserActions {
    asyncGetTypeList = "ASYNC_GET_TYPE_LIST",
    asyncGetBrowserDetails = "ASYNC_GET_BROWSER_DETAILS",
    asyncGetBrowserDetailsByPage = "ASYNC_GET_BROWSER_DETAILS_BY_PAGE",
    asyncGetSearchTypeList = "ASYNC_GET_SEARCH_TYPE_LIST",
    asyncGetSearchDetails = "ASYNC_GET_SEARCH_DETAILS",
    asyncGetDefaultBrowserHistory = "ASYNC_GET_DEFAULT_BROWSER_HISTORY",
    asyncGetTaskListByProjIdAndUid = "ASYNC_GET_TASK_LIST_BY_PROJID_AND_UID",
}

const defaultPagination: BrowserPagination = {
    pageNum: 1,
    pageSize: 10,
}
const defaultSelectedType: SelectedBrowserType = {
    browserType: "",
    browserUser: "",
    infoType: "",
}

const defaultState: BrowserState = {
    taskIdList: [],
    selectedTaskId: "",
    searchTabList: [],
    typeList: [],
    isTypesLoading: false,
    browserDetails: [],
    isDetailsLoading: false,
    isAllDetailsLoaded: false,
    detailsPagination: defaultPagination,
    selectedType: defaultSelectedType,
    detailListMap: {},
    isSearching: false,
    isSearchLoading: false,
    searchTarget: "",
    searchFilter: false,
    searchType: true,
    searchTypeList: {},
    searchDetailListMap: {},
    isDefaultTypeLoading: false,
}

const state: BrowserState = { ...defaultState };

export const getters: GetterTree<BrowserState, RootState> = {
    [BrowserGetters.getTaskIdList](state): Task[] {
        return state.taskIdList
    },
    [BrowserGetters.getSelectedTaskId](state): string {
        return state.selectedTaskId
    },
    [BrowserGetters.getSearchTabList](state): SearchTabNode[] {
        return state.searchTabList
    },
    [BrowserGetters.getTypeList](state): TypeNode[] {
        return state.typeList
    },
    [BrowserGetters.getTypesLoading](state): boolean {
        return state.isTypesLoading
    },
    [BrowserGetters.getDetailsLoading](state): boolean {
        return state.isDetailsLoading
    },
    [BrowserGetters.getDetailsCount]: (state) => (selectBrowser: SelectedBrowserType, taskId: string): number => {
        const detailsType = `${taskId === "" ? "all" : taskId}_${selectBrowser.browserType}_${selectBrowser.browserUser}_${selectBrowser.infoType}`
        if (state.detailListMap[detailsType]) {
            return state.detailListMap[detailsType].count
        } else {
            return 0
        }
    },
    // [BrowserGetters.getIsAllDetailsLoaded]: (state) => (selectBrowser: SelectedBrowserType, taskId: String): boolean => {
    //     const detailsType = `${taskId === "" ? "all" : taskId}_${selectBrowser.browserType}_${selectBrowser.browserUser}_${selectBrowser.infoType}`
    //     if (state.detailListMap[detailsType]) {
    //         return state.detailListMap[detailsType].isAllLoaded
    //     } else {
    //         return false
    //     }
    // },
    [BrowserGetters.getSelectType](state): SelectedBrowserType {
        return state.selectedType
    },
    [BrowserGetters.getBrowserDetails]: (state) => (selectBrowser: SelectedBrowserType, taskId: string): Browser[] => {
        const detailsType = `${taskId === "" ? "all" : taskId}_${selectBrowser.browserType}_${selectBrowser.browserUser}_${selectBrowser.infoType}`

        if (state.detailListMap[detailsType]) {
            return state.detailListMap[detailsType].detailsList
        } else {
            return []
        }
    },
    [BrowserGetters.getIsSearching](state): boolean {
        return state.isSearching
    },
    [BrowserGetters.getIsSearchLoading](state): boolean {
        return state.isSearchLoading
    },
    [BrowserGetters.getIsSearchDetailsLoading]: (state) => (type: string): boolean => {
        if (state.searchDetailListMap[type]) {
            return state.searchDetailListMap[type].isLoading
        } else {
            return false
        }
    },
    [BrowserGetters.getSearchTarget](state): string {
        return state.searchTarget
    },
    [BrowserGetters.getSearchFilter](state): boolean {
        return state.searchFilter
    },
    [BrowserGetters.getSearchType](state): boolean {
        return state.searchType
    },
    [BrowserGetters.getSearchTypes]: (state) => (searchTab: string): BrowserTypesOfSearch[] => {
        if (state.searchTypeList[searchTab]) {
            return state.searchTypeList[searchTab].searchResult
        } else {
            return []
        }
    },
    [BrowserGetters.getSearchDetails]: (state) => (selectBrowser: string): Browser[] => {
        if (state.searchDetailListMap[selectBrowser]) {
            return state.searchDetailListMap[selectBrowser].detailsList
        } else {
            return []
        }
    },
    [BrowserGetters.getIsDefaultTypeLoading](state): boolean {
        return state.isDefaultTypeLoading
    },
}

export const mutations: MutationTree<BrowserState> = {
    [BrowserMutations.setTaskIdList](state, payload: Task[]): void {
        state.taskIdList = payload
    },
    [BrowserMutations.setSelectedTaskId](state, payload: string): void {
        state.selectedTaskId = payload
    },
    [BrowserMutations.setSearchTabList](state, payload: { searchTarget: string, searchTaskId: string }): void {
        let searchTabList = state.searchTabList
        let taskList = state.taskIdList
        let target = {
            searchTarget: payload.searchTarget,
            searchTaskId: payload.searchTaskId,
            searchTask: taskList.find(task => task.id === payload.searchTaskId),
        }
        let index = searchTabList.findIndex(tab => tab.searchTarget === payload.searchTarget && tab.searchTaskId === payload.searchTaskId)
        if (index === -1) {
            searchTabList.push(target)
        } else {
            searchTabList.splice(index, 1);
            searchTabList.push(target);
        }
        state.searchTabList = searchTabList
    },
    [BrowserMutations.deleteSearchTabList](state, payload: SearchTabNode[]): void {
        state.searchTabList = payload
    },

    [BrowserMutations.setTypeList](state, payload: TypeNode[]): void {
        state.typeList = payload
    },
    [BrowserMutations.setTypesLoading](state, payload: boolean): void {
        state.isTypesLoading = payload
    },
    [BrowserMutations.setBrowserDetailsByPage](state, payload: { detailsType: string, browserDetailsList: Browser[], pageSize: number, pageNum: number }): void {
        const browserGroup = state.detailListMap[payload.detailsType]
        if (!browserGroup) {
            state.detailListMap[payload.detailsType] = {
                detailsList: payload.browserDetailsList,
                count: 0,
            }
        } else {
            if (browserGroup.count > 0) {
                let start = payload.pageSize * (payload.pageNum - 1)
                let len = payload.pageSize
                state.detailListMap[payload.detailsType].detailsList.splice(start, len, ...payload.browserDetailsList)
            }
        }
    },
    [BrowserMutations.setBrowserDetails](state, payload: { detailsType: string, browserDetailsList: Browser[], isAppend: boolean }): void {
        const browserGroup = state.detailListMap[payload.detailsType]

        if (!browserGroup) {
            state.detailListMap[payload.detailsType] = {
                detailsList: payload.browserDetailsList,
                count: 0,
            }
        } else {
            if (payload.isAppend) {
                state.detailListMap[payload.detailsType].detailsList = browserGroup.detailsList.concat(payload.browserDetailsList)
            } else {
                state.detailListMap[payload.detailsType].detailsList = payload.browserDetailsList
            }
        }
    },
    [BrowserMutations.setDetailsLoading](state, payload: boolean): void {
        state.isDetailsLoading = payload
    },
    [BrowserMutations.setDetailsCount](state, payload: { detailsType: string, count: number }): void {
        const browserGroup = state.detailListMap[payload.detailsType]
        if (browserGroup) {
            state.detailListMap[payload.detailsType].count = payload.count
        } else {
            state.detailListMap[payload.detailsType] = {
                detailsList: new Array(payload.count),
                count: payload.count,
            }
        }
    },
    // [BrowserMutations.setIsAllDetailsLoaded](state, payload: { detailsType: string, isAllDetailsLoaded: boolean }): void {
    //     const browserGroup = state.detailListMap[payload.detailsType]
    //     if (browserGroup) {
    //         state.detailListMap[payload.detailsType].isAllLoaded = payload.isAllDetailsLoaded
    //     } else {
    //         state.detailListMap[payload.detailsType] = {
    //             detailsList: [],
    //             pagination: { ...defaultPagination },
    //             count: 0,
    //             isAllLoaded: payload.isAllDetailsLoaded,
    //         }
    //     }
    // },
    [BrowserMutations.setSelectedType](state, payload: SelectedBrowserType): void {
        state.selectedType = payload
    },
    [BrowserMutations.setSearchTypes](state, payload: { tab: string, res: BrowserTypesOfSearch[] }): void {
        state.searchTypeList[payload.tab] = {
            searchResult: payload.res
        }
    },
    [BrowserMutations.setIsSearchLoading](state, payload: boolean): void {
        state.isSearchLoading = payload
    },
    [BrowserMutations.setSearchTarget](state, payload: string): void {
        state.searchTarget = payload
    },
    [BrowserMutations.setSearchFilter](state, payload: boolean): void {
        state.searchFilter = payload
    },
    [BrowserMutations.setSearchType](state, payload: boolean): void {
        state.searchType = payload
    },
    [BrowserMutations.setIsSearching](state, payload: boolean): void {
        state.isSearching = payload
    },
    [BrowserMutations.setIsSearchDetailsLoading](state, payload: { detailsType: string, isLoading: boolean }): void {
        if (state.searchDetailListMap[payload.detailsType]) {
            state.searchDetailListMap[payload.detailsType].isLoading = payload.isLoading
        } else {
            state.searchDetailListMap[payload.detailsType] = {
                detailsList: [],
                isLoading: payload.isLoading
            }
        }
    },
    [BrowserMutations.setSearchDetails](state, payload: { detailsType: string, searchDetailsList: Browser[] }): void {
        if (state.searchDetailListMap[payload.detailsType]) {
            state.searchDetailListMap[payload.detailsType].detailsList = payload.searchDetailsList
        } else {
            state.searchDetailListMap[payload.detailsType] = {
                detailsList: payload.searchDetailsList,
                isLoading: false,
            }
        }
    },
    [BrowserMutations.setIsDefaultTypeLoading](state, payload: boolean): void {
        state.isDefaultTypeLoading = payload
    },
    [BrowserMutations.resetAll](state) {
        Object.assign(state, {
            ...defaultState,
            typeList: [],
            browserDetails: [],
            detailListMap: {},
            searchTypeList: [],
            searchTabList: [],
            searchDetailListMap: {},
        })
    },
    [BrowserMutations.resetForChangeTask](state) {
        Object.assign(state, {
            ...defaultState,
            taskIdList: state.taskIdList,
            searchTarget: state.searchTarget,
            searchFilter: state.searchFilter,
            searchTypeList: state.searchTypeList,
            searchDetailListMap: state.searchDetailListMap,
            typeList: [],
            browserDetails: [],
        })
    },

}

export const actions: ActionTree<BrowserState, RootState> = {
    async [BrowserActions.asyncGetBrowserDetailsByPage](
        { commit, getters }: ActionContext<BrowserState, RootState>,
        { projId, uid, browserType, browserUser, infoType, taskId, pageSize, pageNum }: { projId: string, uid: string, browserType: string, browserUser: string, infoType: string, taskId: string, pageSize: number, pageNum: number }
    ): Promise<void> {
        try {
            commit(BrowserMutations.setDetailsLoading, true);
            const reqParams: GetBrowserDetailsByPageReq = { projId: projId, uid: uid, browserType: browserType, browserUser: browserUser, infoType: infoType, taskId: taskId, pageSize: pageSize, pageNum: pageNum };
            const detailsType = `${taskId === '' ? 'all_' : taskId + '_'}${browserType}_${browserUser}_${infoType}`

            const nowCount = getters[BrowserGetters.getDetailsCount]({ "browserType": browserType, "browserUser": browserUser, "infoType": infoType }, taskId)
            if (nowCount === 0) {
                const count: number = await BrowserAPI.getPaginationByBrowserType(reqParams)
                commit(BrowserMutations.setDetailsCount, { detailsType, count });
            }
            const browserDetailsList: Browser[] = await BrowserAPI.getInfoByType(reqParams)
            commit(BrowserMutations.setBrowserDetailsByPage, { detailsType, browserDetailsList, pageSize, pageNum });
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setDetailsLoading, false)
        }
    },
    async [BrowserActions.asyncGetTypeList](
        { commit }: ActionContext<BrowserState, RootState>,
        { projId, uid, taskId }: { projId: string, uid: string, taskId: string }
    ): Promise<void> {
        try {
            commit(BrowserMutations.setTypesLoading, true);
            const typeList: TypeNode[] = await BrowserAPI.getAllBrowserTypeByUid(projId, uid, taskId);
            commit(BrowserMutations.setTypeList, typeList)
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setTypesLoading, false);
        }
    },
    async [BrowserActions.asyncGetSearchTypeList](
        { commit, getters }: ActionContext<BrowserState, RootState>,
        { projId, uid, target, taskId, searchTaskId }: { projId: string, uid: string, target: string, taskId: string, searchTaskId: string }
    ): Promise<void> {
        try {
            commit(BrowserMutations.setIsSearchLoading, true);
            const searchTab: string = searchTaskId + '_' + target
            const isFuzzy = getters[BrowserGetters.getSearchType]
            const res = await BrowserAPI.getTypesOfSearch(projId, uid, target, taskId, isFuzzy)
            commit(BrowserMutations.setSearchTarget, target)
            commit(BrowserMutations.setIsSearching, true)
            commit(BrowserMutations.setSearchTypes, { tab: searchTab, res })
            commit(BrowserMutations.setSearchTabList, { searchTarget: target, searchTaskId: searchTaskId })
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setIsSearchLoading, false);
        }
    },

    async [BrowserActions.asyncGetSearchDetails](
        { commit, getters }: ActionContext<BrowserState, RootState>,
        { projId, uid, target, browserType, browserUser, infoType, taskId }: { projId: string, uid: string, target: string, browserType: string, browserUser: string, infoType: string, taskId: string }
    ): Promise<void> {
        const detailsType = `${taskId === "" ? "all" : taskId}_${target}_${browserType}_${browserUser}_${infoType}`
        try {
            commit(BrowserMutations.setIsSearchLoading, { detailsType: detailsType, isLoading: true });
            const isFuzzy = getters[BrowserGetters.getSearchType]
            const searchDetials: Browser[] = getters[BrowserGetters.getSearchDetails](detailsType)
            const searchFilter: boolean = getters[BrowserGetters.getSearchFilter]
            if (searchDetials.length === 0) {
                const reqParams: GetSearchDetailsReq = { projId: projId, uid: uid, target: target, browserType: browserType, browserUser: browserUser, infoType: infoType, taskId: searchFilter ? taskId : "", searchType: isFuzzy };
                const searchDetailsList: Browser[] = await BrowserAPI.getSearchDetails(reqParams)
                commit(BrowserMutations.setSearchDetails, { detailsType, searchDetailsList });
            }
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setIsSearchLoading, { detailsType: detailsType, isLoading: false });
        }
    },
    async [BrowserActions.asyncGetDefaultBrowserHistory](
        { commit }: ActionContext<BrowserState, RootState>,
        { projId, uid, taskId }: { projId: string, uid: string, taskId: string }
    ): Promise<void> {
        try {
            commit(BrowserMutations.setIsDefaultTypeLoading, true)
            const browserTypeAndUser: string[] = await BrowserAPI.GetDefaultBrowserHistory(projId, uid, taskId)
            if (browserTypeAndUser.length !== 0) {
                commit(BrowserMutations.setSelectedType, { browserType: browserTypeAndUser[0], browserUser: browserTypeAndUser[1], infoType: "History" });
            } else {
                commit(BrowserMutations.setSelectedType, { browserType: "", browserUser: "", infoType: "History" });
            }
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setIsDefaultTypeLoading, false)
        }
    },
    async [BrowserActions.asyncGetTaskListByProjIdAndUid](
        { commit }: ActionContext<BrowserState, RootState>,
        { projId, uid }: { projId: string, uid: string }
    ): Promise<void> {
        try {
            commit(BrowserMutations.setIsDefaultTypeLoading, true)
            const browserTaskList: Task[] = await BrowserAPI.getBrowserTaskListByProjIdAndUid(projId, uid)
            commit(BrowserMutations.setTaskIdList, browserTaskList.filter(task => task.status === TaskStatusEnum.StatusFinished))
            if (browserTaskList.length === 0) {
                commit(BrowserMutations.setSelectedTaskId, "");
            } else {
                commit(BrowserMutations.setSelectedTaskId, browserTaskList[0].id);
            }
        } catch (err) {
            console.log(err)
        } finally {
            commit(BrowserMutations.setIsDefaultTypeLoading, false)
        }
    },

}

export const browser: Module<BrowserState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
